(function () {
  if (window.etellNavigationV42) return;
  window.etellNavigationV42 = true;
  const desktop = window.matchMedia('(min-width: 901px)');
  const itemSelector = '.etell-desktop-nav__item--has-submenu';
  function syncOverlay() {
    document.documentElement.classList.toggle('etell-navigation-open', !!document.querySelector('[data-etell-nav].is-open, .etell-desktop-nav__item--has-submenu.is-open'));
  }

  function setDesktop(item, open) {
    item.classList.toggle('is-open', open);
    const toggle = item.querySelector('[data-etell-desktop-submenu]');
    const panel = item.querySelector('.etell-desktop-nav__submenu');
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    if (panel) {
      panel.hidden = !open;
      if (!open) panel.querySelectorAll('details[open]').forEach(function (group) { group.open = false; });
      if (open) {
        panel.style.marginLeft = '';
        const bounds = panel.getBoundingClientRect();
        const shift = bounds.left < 12 ? 12 - bounds.left :
          (bounds.right > window.innerWidth - 12 ? window.innerWidth - 12 - bounds.right : 0);
        panel.style.marginLeft = shift + 'px';
      }
    }
    syncOverlay();
  }
  function closeDesktop(except) {
    document.querySelectorAll(itemSelector).forEach(function (item) {
      if (item !== except) setDesktop(item, false);
    });
  }
  function setMobile(open) {
    const nav = document.querySelector('[data-etell-nav]');
    const button = document.querySelector('[data-etell-menu]');
    if (nav) {
      nav.classList.toggle('is-open', open);
      if (!open) nav.querySelectorAll('details[open]').forEach(function (group) { group.open = false; });
    }
    if (button) {
      button.setAttribute('aria-expanded', String(open));
      const label = button.querySelector('.visually-hidden');
      if (label) label.textContent = open ? 'Cerrar menú' : 'Abrir menú';
    }
    syncOverlay();
  }
  function reset() { setMobile(false); closeDesktop(); }
  function openDesktop(item) {
    if (!desktop.matches) return;
    closeDesktop(item);
    setDesktop(item, true);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-etell-menu]');
    if (button) {
      setMobile(!desktop.matches && button.getAttribute('aria-expanded') !== 'true');
      return;
    }
    const toggle = event.target.closest('[data-etell-desktop-submenu]');
    if (toggle) {
      const item = toggle.closest(itemSelector);
      const open = desktop.matches && toggle.getAttribute('aria-expanded') !== 'true';
      closeDesktop(item);
      setDesktop(item, open);
      return;
    }
    if (event.target.closest('[data-etell-nav] a')) setMobile(false);
    if (!event.target.closest('[data-etell-nav]')) setMobile(false);
    if (!event.target.closest(itemSelector) || event.target.closest('.etell-desktop-nav__submenu a')) closeDesktop();
  });
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch' || event.target.closest('[data-etell-desktop-submenu]')) return;
    const item = event.target.closest(itemSelector);
    if (item && !item.contains(event.relatedTarget)) openDesktop(item);
  });
  document.addEventListener('pointerout', function (event) {
    const item = event.target.closest(itemSelector);
    if (item && !item.contains(event.relatedTarget) && !item.contains(document.activeElement)) setDesktop(item, false);
  });
  document.addEventListener('focusin', function (event) {
    const item = event.target.closest(itemSelector);
    if (item && !event.target.matches('[data-etell-desktop-submenu]')) openDesktop(item);
    else closeDesktop(item);
    if (!event.target.closest('[data-etell-nav]') && !event.target.closest('[data-etell-menu]')) setMobile(false);
  });
  document.addEventListener('focusout', function (event) {
    const item = event.target.closest(itemSelector);
    if (item && !item.contains(event.relatedTarget)) setDesktop(item, false);
  });
  document.addEventListener('keydown', function (event) {
    const toggle = event.target.closest('[data-etell-desktop-submenu]');
    if (toggle && desktop.matches && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
      event.preventDefault();
      const item = toggle.closest(itemSelector);
      openDesktop(item);
      const links = Array.from(item.querySelectorAll('.etell-desktop-nav__submenu a, .etell-desktop-nav__submenu summary'))
        .filter(function (link) { return link.getClientRects().length > 0; });
      const target = event.key === 'ArrowDown' ? links[0] : links[links.length - 1];
      if (target) target.focus();
      return;
    }
    if (event.key !== 'Escape') return;
    event.preventDefault();
    const nested = event.target.closest('.etell-navigation-nested[open]');
    if (nested) {
      nested.open = false;
      nested.querySelector('summary').focus();
      return;
    }
    const item = event.target.closest(itemSelector);
    const nav = event.target.closest('[data-etell-nav]');
    if (item) {
      const toggle = item.querySelector('[data-etell-desktop-submenu]');
      if (toggle) toggle.focus();
    } else if (nav) {
      const button = document.querySelector('[data-etell-menu]');
      if (button) button.focus();
    }
    reset();
  });
  desktop.addEventListener('change', reset);
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    reset();
  });
  window.addEventListener('pageshow', reset);
  document.addEventListener('shopify:section:load', reset);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reset);
  else reset();
})();
